'use client';

import { memo, type ReactNode } from 'react';

import AssistantSurface from '@features/assistant/AssistantSurface';
import { MODE_ASSISTANT_CONFIG } from '@features/assistant/modeSuggestions';
import { useActivePersonaMode } from 'hooks/useActivePersonaMode';

const AssistantHome = ({ children }: { children?: ReactNode }) => {
  const mode = useActivePersonaMode();
  const config = MODE_ASSISTANT_CONFIG[mode];

  // Key by mode so switching persona resets the conversation/composer state
  // rather than carrying one mode's chat into another (same `positions` route).
  return (
    <AssistantSurface key={mode} config={config}>
      {children}
    </AssistantSurface>
  );
};

export default memo(AssistantHome);
